export default "__VITE_ASSET__BOdrsqRS__"